import React from 'react';
import SettingsForm, { FieldDef } from './SettingsForm';
import platformSettingsService from '../../services/platformSettingsService';
import type { PlatformSettings } from '../../types';

export const FEES_FIELDS: FieldDef[] = [
    { key: 'marketplace_fee_percent', inputMode: 'decimal' },
    { key: 'storefront_fee_percent', inputMode: 'decimal' },
    { key: 'currency' },
];

/** Plattformgebühren (%) und Währung. Die Marktplatz-Gebühr wird beim Anlegen eines Angebots eingefroren. */
const FeesTab: React.FC<{ data: PlatformSettings; onChange: (s: PlatformSettings) => void }> = ({ data, onChange }) => (
    <SettingsForm
        group="fees"
        labelPrefix="platformSettings.fees"
        defs={FEES_FIELDS}
        data={data.fees}
        onSave={async (values) => onChange(await platformSettingsService.update({ fees: values }))}
    />
);

export default FeesTab;
